import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
    useHomeTeamName,
    useAwayTeamName,
} from '~SpectateStore/hooks/eventsHooks';
import { useSortedSelectionsIds } from '~SpectateStore/hooks/selectionsHooks';
import GridScoreSectionUS from './GridScoreSectionUS';
import './styles/gridScores.scss';

const SelectionsGridScoresUS = ({ eventId, marketId }) => {
    const [ t ] = useTranslation();
    const selectionsIds = useSortedSelectionsIds(eventId, marketId);
    const headers = {
        home: useHomeTeamName(eventId) ?? t('sub_mkt_headers.home'),
        away: useAwayTeamName(eventId) ?? t('sub_mkt_headers.away'),
        draw: t('sub_mkt_headers.draw'),
    };

    return (
        <div className='score-grid-us'>
            {
                Object.keys(headers).map(key =>
                    <GridScoreSectionUS
                        key={`GridScoresUS-${marketId}-${key}`}
                        selectionsIds={selectionsIds[key]}
                        headerName={headers[key]}
                        sectionKey={key}
                    />
                )
            }
        </div>
    );
};

SelectionsGridScoresUS.propTypes = {
    eventId: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
    marketId: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
};

export default SelectionsGridScoresUS;

